import * as React from 'react';
import H1 from '../../../../components/Layout/H1/H1';
import AppMainCol from '../../../../components/Layout/PageGrid/AppMainCol';
import AppMainColBox from '../../../../components/Layout/PageGrid/AppMainColBox';
import AppSideCol from '../../../../components/Layout/PageGrid/AppSideCol';
import PageWrapper from '../../../../components/Layout/PageWrapper/PageWrapper';
import Row from '../../../Base/components/Grid/Row';
import { SlugType } from '../../../Base/types/SlugType';
import BrandListContainer from '../../containers/BrandList/BrandListContainer';
import ThemeworldListWidgetContainer from '../../../Themeworld/containers/ThemeworldListWidget/ThemeworldListWidgetContainer';
import { IThemeworldWidgetType } from 'App/modules/Themeworld/types/IThemeworldWidget';
import { IWithRouteMetadataType } from 'App/types/IWithRouteMetadataType';
import AdItem from '../../../../components/General/AdItem/AdItem';


interface IBrandsWithFirstLetterProps {
	letter: SlugType;
	title: string;
}

class BrandsWithFirstLetter extends React.Component<IBrandsWithFirstLetterProps & IWithRouteMetadataType, {}> {
	public static defaultProps = {};

	public render() {
		const { letter, title } = this.props;

		return (
			<PageWrapper breadcrumbs={this.getBreadcrumbs()}>

				<AdItem
					desktopAdId={4403492}
					maxHeight={250}
					type="billboard"
				/>

				<H1>
					{title}
				</H1>

				<Row>
					<AppMainCol boxed={true} onTop={true} >
						<AppMainColBox nested={true} boxed={true}>

							<BrandListContainer
								initialLetter={letter}
								contentBreaks={{
									10: (
										<AdItem
											mobileAdId={4403480}
											maxHeight={250}
											type="content"
											title="Mobile Rectangle 1"
										/>
									),
									20: (
										<AdItem
											mobileAdId={4403479}
											maxHeight={250}
											type="content"
											title="Mobile Rectangle 2"
										/>
									)
								}}
							/>

						</AppMainColBox>
					</AppMainCol>

					<AppSideCol boxed={true} onTop={true}>
						<div>

							<ThemeworldListWidgetContainer
								widgetKey={`brands-${letter}-themeworld-widget`}
								title="Themenwelten"
								routeCallbk={this.routerCallbkThemeworldListWidget}
								limit={10}
								orderBy="title"
								orderDir="asc"
								btnRoute="ThemeworldListingRoute"
								btnLabel="Alle Themewelten"
							/>

							<AdItem
								desktopAdId={4403491}
								maxHeight={250}
								maxWidth={300}
								type="content"
								title="Medium Rectangle 1"
							/>

						</div>
					</AppSideCol>
				</Row>

			</PageWrapper>
		);
	}

	/**
	 * Returns the breadcrumb path for this page
	 */
	private getBreadcrumbs () {
		return [
			{
				label: 'Marken Übersicht',
				route: 'BrandListingRoute',
			} as IBreadcrumbItemType,
			{
				label: 'Marken mit ' + this.props.letter.toUpperCase(),
			} as IBreadcrumbItemType,
		];
	}


	/**
	 * Defines the route the brand list widget should be routed towards
	 */
	private routerCallbkThemeworldListWidget = (item: IThemeworldWidgetType) => {
		return {
			name: 'ThemeworldDetailRoute',
			params: {
				themeworld: item.slug,
			},
		};
	}
}

export default BrandsWithFirstLetter;
